// extracted by mini-css-extract-plugin
export default {"Img":"wX_I0HKv","Icon":"FBhjX4fL"};